export default function Contact() {
  return (
    <section id="contact" className="relative py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[800px] mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-medium text-accent-400 bg-accent-500/10 rounded-full mb-4">
            联系我们
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50">
            与我们取得联系
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-400 max-w-2xl mx-auto">
            商务合作、内容投稿或问题反馈，欢迎随时联系我们
          </p>
        </div>

        <div className="bg-background-200/60 rounded-2xl border border-background-300/30 overflow-hidden">
          <div className="p-8 md:p-10">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="text-center p-5 rounded-xl bg-background-50 border border-background-300/20 hover:border-primary-500/20 transition-colors cursor-pointer">
                <div className="w-12 h-12 mx-auto mb-3 rounded-xl bg-primary-500/10 flex items-center justify-center">
                  <i className="ri-mail-line text-primary-400 text-xl"></i>
                </div>
                <h3 className="font-heading text-sm font-semibold text-foreground-100 mb-1">商务合作</h3>
                <p className="text-xs text-foreground-500">bd@taozicinema.com</p>
              </div>
              <div className="text-center p-5 rounded-xl bg-background-50 border border-background-300/20 hover:border-accent-500/20 transition-colors cursor-pointer">
                <div className="w-12 h-12 mx-auto mb-3 rounded-xl bg-accent-500/10 flex items-center justify-center">
                  <i className="ri-send-plane-line text-accent-400 text-xl"></i>
                </div>
                <h3 className="font-heading text-sm font-semibold text-foreground-100 mb-1">内容投稿</h3>
                <p className="text-xs text-foreground-500">submit@taozicinema.com</p>
              </div>
              <div className="text-center p-5 rounded-xl bg-background-50 border border-background-300/20 hover:border-secondary-500/20 transition-colors cursor-pointer">
                <div className="w-12 h-12 mx-auto mb-3 rounded-xl bg-secondary-500/10 flex items-center justify-center">
                  <i className="ri-question-answer-line text-secondary-400 text-xl"></i>
                </div>
                <h3 className="font-heading text-sm font-semibold text-foreground-100 mb-1">问题反馈</h3>
                <p className="text-xs text-foreground-500">support@taozicinema.com</p>
              </div>
            </div>

            <div className="mt-8 pt-6 border-t border-background-300/20">
              <div className="flex flex-wrap items-center justify-center gap-4 text-xs text-foreground-500">
                <span className="flex items-center gap-1.5">
                  <i className="ri-time-line text-foreground-400"></i>
                  工作日 9:00 - 21:00
                </span>
                <span className="hidden sm:inline text-foreground-600">|</span>
                <span>响应时间：2小时内</span>
                <span className="hidden sm:inline text-foreground-600">|</span>
                <span className="flex items-center gap-1.5">
                  <i className="ri-shield-check-line text-foreground-400"></i>
                  官方认证平台
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}